import { formatPaymentMethodLabel, PaymentMethod } from '@domains/pdp-common';
import { GetPaymentNotificationList_payment_notification_list_item_list_payment_notification_content_list as payment_notification_content_list } from '@domains/pdp-common';

interface GetPaymentBenefitTextProps {
  language: 'ko' | 'en' | 'ja';
  payment_method: PaymentMethod;
  payment_method_type: string | null;
  financial_company_code: string;
  payment_notification_content_list: payment_notification_content_list[];
}
export const getPaymentBenefitText = ({
  language,
  payment_method,
  payment_method_type,
  financial_company_code,
  payment_notification_content_list,
}: GetPaymentBenefitTextProps) => {
  try {
    if (payment_notification_content_list?.length) {
      const content = payment_notification_content_list
        .filter((c) => c.language === language && !!c.content.trim().length)[0]
        .content?.replace(/\*\*\*(.*?)\*\*\*/g, `$1`);
      return `${content}`;
    }
    return formatPaymentMethodLabel(language, financial_company_code, payment_method, payment_method_type);
  } catch (e: any) {
    console.error(e);
    return '';
  }
};
